import { type RouteComponentProps, useLocation } from "react-router";

import { parseParams } from "utilities/url/url";

import { type SystemFilterType } from "handlers";

export function getSystemFilter({
    location,
}: Pick<RouteComponentProps, "location">): SystemFilterType | undefined {
    const params = parseParams<{
        filter: SystemFilterType;
    }>(location.search);
    return params.filter ?? undefined;
}

export function useSystemFilter(): SystemFilterType | undefined {
    const location = useLocation();
    return getSystemFilter({ location });
}
